<template>
  <svg
    width="50"
    height="26"
    viewBox="0 0 50 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 13C20 15.7571 22.2429 18 25 18C27.757 18 30 15.7571 30 13C30 10.2429 27.757 8 25 8C22.2429 8 20 10.2429 20 13ZM27.0588 13C27.0588 14.1353 26.1352 15.0588 25 15.0588C23.8647 15.0588 22.9412 14.1353 22.9412 13C22.9412 11.8647 23.8647 10.9412 25 10.9412C26.1352 10.9412 27.0588 11.8647 27.0588 13Z"
      fill="white"
    />
    <path
      d="M49.6663 11.9979C45.1219 6.46126 35.5007 0 25 0C14.4617 0 4.84004 6.50518 0.333676 11.9979C-0.111225 12.5402 -0.111225 13.3212 0.333676 13.8634C4.98582 19.534 14.6296 25.8614 25 25.8614C35.7389 25.8614 45.3192 19.1598 49.6663 13.8635C50.1112 13.3212 50.1112 12.5402 49.6663 11.9979ZM34.9895 12.9307C34.9895 18.4389 30.5082 22.9203 24.9999 22.9203C19.4915 22.9203 15.0103 18.4386 15.0103 12.9307C15.0103 7.42244 19.4916 2.94107 24.9999 2.94107C30.5087 2.94117 34.9895 7.42303 34.9895 12.9307ZM3.4571 12.9311C5.11229 11.2108 9.10327 7.49812 14.7057 5.11528C11.1898 9.73508 11.1885 16.1224 14.704 20.7439C10.4443 18.9385 6.48729 16.0861 3.4571 12.9311ZM35.2943 20.746C38.8102 16.1261 38.8114 9.7389 35.296 5.11744C39.5555 6.92283 43.5126 9.77528 46.5429 12.9302C44.8877 14.6507 40.8967 18.3631 35.2943 20.746Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
    name: 'Visibility'
}
</script>